import React from 'react';
import Modal from 'react-modal';
import classnames from 'classnames';
import styles from './ModalPopup.module.scss';

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
if (process.env.NODE_ENV !== 'test') Modal.setAppElement('#root');

export interface ModalPopupProps extends Modal.Props {
  children: React.ReactNode,
  customModalStyles?: string,
  customOverlayStyles?: string,
}

const ModalPopup = ({
                      children,
                      customModalStyles,
                      customOverlayStyles,
                      ...rest
                    }: ModalPopupProps) => {
  return (
    <>
      <Modal
        {...rest}
        className={classnames(styles.modalContainer, customModalStyles)}
        overlayClassName={classnames(styles.overlay, customOverlayStyles)}
        ariaHideApp={false}
      >
        {children}
      </Modal>
    </>
  );
};

export default ModalPopup;
